/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
  Alert,
  Button,
  Form,
  ButtonGroup,
  InputGroup,
  Card,
  Container,
  Dropdown,
  Modal,
  Spinner,
} from "@themesberg/react-bootstrap";
import { Routes } from "../../../routes";
import { useState } from "react";
import { useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "react-hot-toast";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { fetchUserData } from '';
import { faCheck, faEye, faPrint, faSync } from "@fortawesome/free-solid-svg-icons";

import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import moment from "moment-timezone";
import { SearchContext } from "../../HomePage";
import { deleteApi, fetchApi, postApi } from "../../../redux/api";
import { formatNumber } from "../../../redux/utils";
import SearchInput from "../../../components/SearchInput";
import CustomTable from "../../../components/CustomTable";

function DirectTransferList({ match, type = null }) {
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const location = useLocation();
  const isPending = location.pathname.includes("payapp");
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif"];
  const [filterText, setFilterText] = useState("");
  const batch_no = useParams().batch_no;
  const [budgetUtilization, setBudgetUtilization] = useState([]);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState(type || "All");
  const [attachmentModalIsOpen, setAttachmentModalIsOpen] = useState(false);
  const [selectedApproval, setApprovalNo] = useState("");
  const [returndApproval, retApprovalNo] = useState("");

  const [approvalImageInfo, setApprovalImageInfo] = useState([]);
  const [item, setItem] = useState({});
  const [_delete, setDelete] = useState(false);

  const [dateFrom, setDateFrom] = useState(
    moment().subtract(1, "month").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));

  const toggleDelete = (item) => {
    setItem(item);
    setDelete(!_delete);
  };
  const [showRemark1, setShowRemark1] = useState(false);
  const [showRemark, setShowRemark] = useState(false);
  const [remark, setRemark] = useState("");
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [returnlLoading, setReturnLoading] = useState(false);
  const [returnlMessage, setReturnMessage] = useState(null);
  const [approvalMessage, setApprovalMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [selectedReleases, setSelectedReleases] = useState([]);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [preparingSchedule, setPreparingSchedule] = useState(false);

  const toggleRemark = () => setShowRemark((p) => !p);
  const [loading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [viewItem, setViewItem] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [verifyLoadingId, setVerifyLoadingId] = useState(null);

  const loadTransfers = useCallback(() => {
    setIsLoading(true);
    fetchApi(
      `direct-transfer/transactions?date_from=${dateFrom}&date_to=${dateTo} `
    )
      .then((resp) => {
        setIsLoading(false);
        if (resp) {
          setList(resp.data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [dateFrom, dateTo]);

  const handleVerify = async (item) => {
    setVerifyLoadingId(item.id);
    try {
      const resp = await postApi(`direct-transfer/verify/${item.id}`);
      if (resp?.success) {
        toast.success(resp.message || "Transfer verified");
        loadTransfers();
      } else {
        toast.error(resp?.message || "Verification failed");
      }
    } catch (err) {
      toast.error(err?.message || "Verification failed");
    } finally {
      setVerifyLoadingId(null);
    }
  };

  const openView = (item) => {
    setViewItem(item);
    setShowViewModal(true);
  };

  const handlePrint = (item) => {
    setViewItem(item);
    setShowViewModal(true);
    setTimeout(() => window.print(), 350);
  };

  const closeView = () => {
    setShowViewModal(false);
    setViewItem(null);
  };

  useEffect(() => {
    loadTransfers();
  }, [loadTransfers]);
  const isProcessingStatus = (status) =>
    ["PROCESSING", "PENDING"].includes(String(status || "").toUpperCase());

  const getStatusBadgeClass = (status) => {
    const normalized = String(status || "").trim().toUpperCase();
    if (normalized === "SUCCESS") return "dt-status-success";
    if (normalized === "FAILED" || normalized === "FAIL") return "dt-status-failed";
    if (normalized === "PROCESSING" || normalized === "PENDING") {
      return "dt-status-processing";
    }
    return "dt-status-default";
  };

  const fields = [
    {
      title: "Date",
      custom: true,
      component: (item) => (
        <div className="text-center">
          {moment(item.createdAt).format("YYYY-MM-DD")}
        </div>
      ),
      //   value: "payment_batch_id",
    },
    {
      title: 'Payment Description',
      custom: true,
      component: (item, index) => <div>{item.description}</div>,
    },
    {
      title: "Amount",
      //   value: "approvals",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },

    {
      title: "Status",
      custom: true,
      component: (item) => (
        <div className="text-center">
          <span className={`dt-status-badge ${getStatusBadgeClass(item.status)}`}>
            {item.status}
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      custom: true,
      style: { minWidth: 260, whiteSpace: "nowrap" },
      component: (item) => (
        <div
          className="d-flex flex-wrap justify-content-center gap-1"
          style={{ minWidth: 240 }}
        >
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => openView(item)}
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
            View
          </Button>
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => handlePrint(item)}
          >
            <FontAwesomeIcon icon={faPrint} className="me-1" />
            Print
          </Button>
          {isProcessingStatus(item.status) && (
            <Button
              size="sm"
              variant="warning"
              disabled={verifyLoadingId === item.id}
              onClick={() => handleVerify(item)}
            >
              <FontAwesomeIcon
                icon={verifyLoadingId === item.id ? faSync : faCheck}
                spin={verifyLoadingId === item.id}
                className="me-1"
              />
              {verifyLoadingId === item.id ? "Verifying..." : "Verify"}
            </Button>
          )}
        </div>
      ),
    },
  ];

  const modalFields = [
    {
      title: "Approval No",
      value: "approval_no",
    },
    {
      title: "Release Date",
      value: "approval_date",
    },
    {
      title: "MDA Name",
      value: "mda_name",
    },

    {
      title: "Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.amount)}</div>
      ),
    },
  ];

  // const ApprovalCollectionIndex = () => {
  //   const { searchTerm, setSearchTerm } = useContext(SearchContext);
  //   // ... rest of the code
  // };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, [setSearchTerm]);

  const totalReleases = selectedReleases.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );

  return (
    <>
      <style>
        {`
          .dt-status-badge {
            display: inline-block;
            font-size: 0.8rem;
            font-weight: 600;
            padding: 0.35em 0.75em;
            border-radius: 10rem;
            line-height: 1.2;
          }
          .dt-status-success {
            background-color: #198754 !important;
            color: #fff !important;
          }
          .dt-status-failed {
            background-color: #dc3545 !important;
            color: #fff !important;
          }
          .dt-status-processing {
            background-color: #ffc107 !important;
            color: #212529 !important;
          }
          .dt-status-default {
            background-color: #6c757d !important;
            color: #fff !important;
          }
        `}
      </style>
      {/* {JSON.stringify(list)} */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        {/* <Button
          onClick={() => {}}
          className="me-2 bg-success"
        >
          Add Approval
        </Button> */}

        <h4>
          {/* <FontAwesomeIcon icon={faListUl} className="me-2" />  */}
          Direct Transfer
        </h4>

        {/* {JSON.stringify(searchTerm)} */}
        {/* <div className="btn-toolbar mb-2 mb-md-0">
          <h5>Total Amount Selected: {totalReleases.toLocaleString()}</h5>
        </div> */}
      </div>
      {/* <SearchInput
        placeholder="Search For Releases"
        value={searchTerm}
        onChange={({ target: { value } }) => setSearchTerm(value)}
      /> */}

      <Row>
        <Col
          md={6}
          style={{
            marginTop: 28,
          }}
        >
          {/* <SearchInput
            placeholder="Search For All Schedule"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          /> */}
          <Button
            onClick={() => history(`${Routes.paymentRequest.directTransfer}`)}
          >
            Transfer
          </Button>
        </Col>
        <Col md={6}>
          <Row
            style={{
              marginBottom: 10,
            }}
          >
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div style={{ height: "60vh", overflow: "scroll" }}>
              <CustomTable fields={fields} data={list} />
            </div>
          )}
          {/* {JSON.stringify(finalList)} */}
        </Card.Body>

        {/* <Modal size="xl" show={scheduleModalOpen} onHide={() => setScheduleModalOpen(p=>!p)}>
            <Modal.Header>Preview Schedule</Modal.Header>
            <Modal.Body>
            <CustomTable
                fields={modalFields}
                data={selectedReleases}
              />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={prepareSchedule}><FontAwesomeIcon icon={faCheck} /> Continue</Button>
            </Modal.Footer>
        </Modal> */}

        {/* {budgetUtilization.length ? <center>
            <CustomButton loading={preparingSchedule} onClick={() => setScheduleModalOpen(true)}>Raise Payment Request</CustomButton>
        </center> : null} */}
      </Card>

      <Modal
        size="lg"
        show={showViewModal}
        onHide={closeView}
        className="direct-transfer-view-modal"
      >
        <Modal.Header closeButton className="direct-transfer-modal-header">
          <Modal.Title>Direct Transfer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <style>
            {`
              .direct-transfer-print-content {
                font-family: Arial, sans-serif;
              }
              .direct-transfer-print-header {
                text-align: center;
                margin-bottom: 24px;
              }
              .direct-transfer-print-header img {
                width: 80px;
                margin-bottom: 12px;
              }
              .direct-transfer-print-title {
                font-weight: bold;
                font-size: 1.1rem;
              }
              .direct-transfer-details-table {
                width: 100%;
                border-collapse: collapse;
              }
              .direct-transfer-details-table th,
              .direct-transfer-details-table td {
                border: 1px solid #dee2e6;
                padding: 10px 12px;
                text-align: left;
                vertical-align: top;
              }
              .direct-transfer-details-table th {
                width: 35%;
                background: #f8f9fa;
              }
              @media print {
                body * {
                  visibility: hidden;
                }
                .direct-transfer-print-content,
                .direct-transfer-print-content * {
                  visibility: visible;
                }
                .direct-transfer-print-content {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  padding: 24px;
                }
                .direct-transfer-modal-header,
                .direct-transfer-modal-footer {
                  display: none !important;
                }
              }
            `}
          </style>
          {viewItem && (
            <div className="direct-transfer-print-content">
              <div className="direct-transfer-print-header">
                <img
                  src={require("../../../assets/img/KTSG.png")}
                  alt="KTSG Logo"
                />
                <div className="direct-transfer-print-title">
                  KATSINA STATE GOVERNMENT
                </div>
                <div>Office of the Accountant-General</div>
                <div className="mt-2">
                  <strong>Direct Transfer Receipt</strong>
                </div>
              </div>
              <table className="direct-transfer-details-table">
                <tbody>
                  <tr>
                    <th>Date</th>
                    <td>{moment(viewItem.createdAt).format("DD/MM/YYYY HH:mm")}</td>
                  </tr>
                  <tr>
                    <th>Payment Description</th>
                    <td>{viewItem.description || "-"}</td>
                  </tr>
                  <tr>
                    <th>Amount</th>
                    <td>N{formatNumber(viewItem.amount)}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{viewItem.status || "-"}</td>
                  </tr>
                  <tr>
                    <th>Payment Reference</th>
                    <td>{viewItem.payment_ref || "-"}</td>
                  </tr>
                  <tr>
                    <th>Batch Reference</th>
                    <td>{viewItem["batch-reference"] || "-"}</td>
                  </tr>
                  <tr>
                    <th>Batch Description</th>
                    <td>{viewItem["batch-description"] || "-"}</td>
                  </tr>
                  <tr>
                    <th>Approval Reference</th>
                    <td>{viewItem.reference || "-"}</td>
                  </tr>
                  <tr>
                    <th>Beneficiary Name</th>
                    <td>{viewItem.ben_name || "-"}</td>
                  </tr>
                  <tr>
                    <th>Beneficiary Account</th>
                    <td>{viewItem.ben_acc || "-"}</td>
                  </tr>
                  <tr>
                    <th>Beneficiary Bank</th>
                    <td>{viewItem.ben_bank || "-"}</td>
                  </tr>
                  <tr>
                    <th>Account Type</th>
                    <td>{viewItem.ben_acc_type || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="direct-transfer-modal-footer">
          <Button variant="secondary" onClick={closeView}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => viewItem && handlePrint(viewItem)}
          >
            <FontAwesomeIcon icon={faPrint} className="me-1" />
            Print
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DirectTransferList;
